module.exports = __webpack_public_path__ + "static/img/charm_level_82.fdc06b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_82.png
// module id = Yoot
// module chunks = 0